module.exports = __webpack_public_path__ + "static/media/2021_2A3A0766.3cad6a54.jpg";